import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import PageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { Schedule } from '@bookings/interfaces/schedule';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
// import ScheduleForm from '@bookings/components/forms/schedules/schedule-form/schedule-form.vue';
import BpcScheduleForm from '@bookings/components/forms/schedules/schedule-form.vue';
@Component({
  name: 'bpc-schedule-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': PageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,

    // 'bpc-schedule-form': ScheduleForm,
    'bpc-drawer-modal': DrawerModal,
    BpcScheduleForm,
  },
})
export default class ScheduleTable extends mixins(AbstractTable) {
  @Prop(String) declare readonly displayConfigName: string;
  @Prop(String) declare readonly title: string;
  @Prop(String) declare readonly subtitle: string;

  public entity: Schedule = null;
  public entityName = 'schedule';
  public pluralEntityName = 'schedules';
  public permissionEntityNameToUse = 'schedules';
  public showDrawerSettingSection: boolean = false;
  public showSettingForm: boolean = false;

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded', // TODO: Check if this should be in the AbstractTable class
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  onEntityUpdated($event: any = null) {
    this.onFormClose();
    this.$refs.provider.getEntities();
  }

  onEntityCreated($event: any = null) {
    this.entity = $event;
    this.i++;
    this.$refs.provider.getEntities();
  }
}
